





















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NavDrawer extends Vue {
  @Prop() private value!: boolean;

  get darkMode(): boolean {
    return this.$vuetify.theme.dark;
  }

  set darkMode(dark) {
    this.$vuetify.theme.dark = dark;
    localStorage.darkMode = dark;
  }
}
